module.exports = __webpack_public_path__ + "static/media/21.45481f22.png";